function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 11.25h9c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3.05l1.99-2.82a.74.74 0 00-.18-1.04.74.74 0 00-1.04.18l-2.3 3.26-2.3-3.26a.743.743 0 00-1.04-.18c-.34.24-.42.71-.18 1.04l1.99 2.82H7.52c-.41 0-.75.34-.75.75s.32.75.73.75zm9 1.5h-9c-.41 0-.75.34-.75.75s.34.75.75.75h2.87l-1.99 2.82a.74.74 0 00.18 1.04c.13.09.28.14.43.14.24 0 .47-.11.61-.32l2.3-3.26 2.3 3.26c.15.21.38.32.61.32.15 0 .3-.04.43-.14.34-.24.42-.71.18-1.04l-1.99-2.82h3.05c.41 0 .75-.34.75-.75s-.32-.75-.73-.75z"
})));